import React from 'react';
import { withRouter } from 'react-router-dom';
import { Level, Title } from 'rbx';
import styled from 'styled-components';
import { startCase } from 'lodash';
import { ACLSConsumer } from '../../../utils/aclsContext';
import Can from '../../../utils/Can';

const Wrapper = styled.div`
  padding: 1rem 1rem;
  border-bottom: 1px solid #f6f6f6;
`;

const Header = ({
  values,
  location,
  history,
  loading,
  dirty,
  children,
  groupName,
  isAdd,
  saveAndAddMore,
  setSaveAndAddMore,
  handleSubmit,
}) => (
  <Wrapper>
    <Level>
      <Level.Item align="left">
        <Title className="is-size-2">Add Modifier Group</Title>
      </Level.Item>
      <Level.Item align="right">
        <Level.Item>
          <a onClick={() => history.goBack()} className="button is-grey">
            <span className="has-text-weight-semibold">Cancel</span>
          </a>
        </Level.Item>
        {isAdd && (
          <ACLSConsumer>
            {({ apiActions, pageActions }) => (
              <Can
                action={`${
                  location.pathname === '/update-modifiers-group'
                    ? 'update_menu_modifier_group'
                    : 'create_menu_modifier_group'
                }`}
                apiActions={apiActions}
                pageActions={pageActions}
                yes={() => (
                  <Level.Item>
                    <button
                      type="button"
                      className={`button is-primary ${saveAndAddMore &&
                        loading &&
                        'is-loading'}`}
                      disabled={values.modifier.length === 0 || !dirty}
                      onClick={() => {
                        if (!saveAndAddMore && loading) {
                          return;
                        }
                        setSaveAndAddMore(true);
                        handleSubmit();
                      }}
                    >
                      <span className="has-text-weight-semibold">
                        Submit And Add More
                      </span>
                    </button>
                  </Level.Item>
                )}
              />
            )}
          </ACLSConsumer>
        )}
        <ACLSConsumer>
          {({ apiActions, pageActions }) => (
            <Can
              action={`${
                location.pathname === '/update-modifiers-group'
                  ? 'update_menu_modifier_group'
                  : 'create_menu_modifier_group'
              }`}
              apiActions={apiActions}
              pageActions={pageActions}
              yes={() => (
                <Level.Item>
                  <button
                    type="button"
                    className={`button is-primary ${!saveAndAddMore &&
                      loading &&
                      'is-loading'}`}
                    onClick={
                      !isAdd
                        ? handleSubmit
                        : () => {
                            if (saveAndAddMore && loading) {
                              return;
                            }
                            setSaveAndAddMore(false);
                            handleSubmit();
                          }
                    }
                    disabled={values.modifier.length === 0 || !dirty}
                  >
                    <span className="has-text-weight-semibold">Submit</span>
                  </button>
                </Level.Item>
              )}
            />
          )}
        </ACLSConsumer>
      </Level.Item>
    </Level>
    <p className="is-size-2">{startCase(groupName)}</p>
    {children}
  </Wrapper>
);

export default withRouter(Header);
